export const moduleWiseDataTransport = `query moduleWiseDataTransport($filter: ModuleWiseDTRequest!) {
  moduleWiseDataTransport(filter: $filter) {
    response
    message
  }
}`;


export const completeModelAvailability = `mutation($input: CompleteModelAvailabilityRequest!) {
  completeModelAvailability(input: $input) {
    response
    message
  }
}`;

export const completeMaterialAvailability = `mutation CompleteMaterialAvailability($input: CompleteMatrAvailabilityRequest!) {
  completeMaterialAvailability(input: $input) {
    response
    message
  }
}`;

export const completeServiceAvailability = `mutation CompleteServiceAvailability($input: CompleteServiceAvailabilityRequest!) {
  completeServiceAvailability(input: $input) {
    response
    message
  }
}`;

export const completeDefaultLoc = `mutation CompleteDefaultLoc($input: CompleteDefaultLocRequest!) {
  completeDefaultLoc(input: $input ) {
    message
    response
  }
}`;

export const completeLocalizationAvailability = `mutation CompleteLocalizationAvailability($input: CompleteLocalizationAvailabilityRequest!) {
  completeLocalizationAvailability(input: $input) {
    message
    response
  }
}`;

export const completeParameter = `mutation CompleteParameter($input: CompleteParameterRequest!) {
  completeParameter(input: $input) {
    message
    response
  }
}`;

export const dataTransport = `query DataTransport($filter: DataTransportRequest!) {
  dataTransport(filter: $filter) {
    response
    message
  }
}`;

export const GetDataTransportLoadCount = `query GetDataTransportLoadCount($moduleName: String!) {
  dataTransportLoadCount(filter: { moduleName: $moduleName }) {
    loadCount
  }
}`;